import { render } from "./UserStatisticsComponent.vue?vue&type=template&id=f2d64a66"
import script from "./UserStatisticsComponent.vue?vue&type=script&lang=js"
export * from "./UserStatisticsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__